// Cart drawer content (#CartDrawer) gets fully re-rendered from the server
// on every cart update (see CartDrawer.renderContents in cart-drawer.js),
// which destroys and recreates the checkbox and button as fresh DOM nodes.
// Listening on document with delegation means there's nothing to re-bind
// after a re-render — each fresh checkbox/button pair already starts in a
// matching default state (unchecked / disabled) straight from the Liquid
// markup, so this only ever needs to react to an actual user toggle.
document.addEventListener('change', function (event) {
  var checkbox = event.target.closest('#CartDrawer-DutiesAcknowledgment');
  if (!checkbox) return;

  var checkoutButton = document.getElementById('CartDrawer-Checkout');
  if (checkoutButton) checkoutButton.disabled = !checkbox.checked;
});
